// extracted by mini-css-extract-plugin
export var assigneeBadge = "_nj-0";
export var assigneeDetails = "_nj-1";
export var assigneeInfo = "_nj-2";
export var dropdownContainer = "_nj-4";
export var dropdownImage = "_nj-5";
export var editAssigneeInfo = "_nj-3";
export var editAssigneeModalContainer = "_nj-6";
export var hidden = "_nj-8";
export var input = "_nj-7";